import { TokenInputWithPrice, BalanceDisplay } from "app/components/common";
import { COPY } from "app/constants";
import {
    isVaultDepositButtonEnabledWithGenesisRelease,
    LendingVaultExpanded,
    summarizeVaultSuppliedDeposits,
    useUserGenesisWhitelisted
} from "@bridgesplit/abf-react";
import { roundDownToDecimals } from "@bridgesplit/utils";

import { useVaultDepositContext } from "./VaultDepositContext";
import { useVaultContext } from "../VaultContext";
import { useDepositUpdateAmount, useVaultDepositBalance } from "./util";

export default function VaultDepositAmount() {
    const { form } = useVaultDepositContext();
    const { isUserGenesisWhitelisted } = useUserGenesisWhitelisted();
    const { vaultExpanded } = useVaultContext();
    const updateAmount = useDepositUpdateAmount();

    const { balance, insufficientBalance, isLoading } = useVaultDepositBalance();

    const enabled = isVaultDepositButtonEnabledWithGenesisRelease(vaultExpanded, isUserGenesisWhitelisted);

    return (
        <TokenInputWithPrice
            disabled={!enabled}
            label={`You ${COPY.VAULT_DEPOSIT_CTA.toLowerCase()}`}
            value={form.amount}
            setValue={updateAmount}
            metadata={vaultExpanded?.principalMetadata}
            selectToken={null}
            belowInput={
                <BalanceDisplay
                    balance={balance}
                    metadata={vaultExpanded?.principalMetadata}
                    insufficientBalance={insufficientBalance}
                    isLoading={isLoading}
                    setMax={getSetMaxFunction(updateAmount, vaultExpanded)}
                />
            }
        />
    );
}

function getSetMaxFunction(
    originalSetMax: (amount: number | undefined) => void,
    vaultExpanded: LendingVaultExpanded | undefined
) {
    if (!vaultExpanded) return undefined;
    const principalDecimals = vaultExpanded?.principalMetadata?.decimals ?? 0;

    const { supplyLimitReached, principalLimit, principalSupplied, isDepositRestricted } =
        summarizeVaultSuppliedDeposits(vaultExpanded);

    if (supplyLimitReached) return undefined;
    if (!isDepositRestricted) return originalSetMax;

    function setMax(amount: number | undefined) {
        if (!amount) return;
        const maxGenesisVaultDeposit = roundDownToDecimals(principalLimit - principalSupplied, principalDecimals);
        const max = Math.min(amount, maxGenesisVaultDeposit);
        originalSetMax(max);
    }

    return setMax;
}
